import { Helmet } from "react-helmet-async";

const SITE = "https://samperlabs.com";
const ogImage = `${SITE}/og-share.png?v=1`;

function canonicalUrl(canonicalPath) {
  if (!canonicalPath || canonicalPath === "/") return `${SITE}/`;
  const p = canonicalPath.startsWith("/") ? canonicalPath : `/${canonicalPath}`;
  return `${SITE}${p}`;
}

/**
 * Per-route title, description, canonical, Open Graph / Twitter, and optional JSON-LD.
 */
export default function SEOHead({ title, description, canonicalPath, jsonLd }) {
  const url = canonicalUrl(canonicalPath);
  const ld =
    jsonLd &&
    JSON.stringify(jsonLd).replace(/</g, "\\u003c");

  return (
    <Helmet prioritizeSeoTags>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="SamperLabs" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      {ld ? (
        <script type="application/ld+json">{ld}</script>
      ) : null}
    </Helmet>
  );
}
